<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><em>For Matthew Daniel Walpole<br/>with happy wishes</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780545388856_epub_ded_r1.vue?4379fc22